import { PHONE, locationSchema } from "../structured-data-core";

export function getBrooklynHeightsStructuredData() {
  const url = "https://restorehair.com/locations/new-york/brooklyn-heights/";
  const description =
    "Find out about your hair transplant options in Brooklyn Heights with RESTORE Hair. Over 20,000 procedures performed.";
  return [
    locationSchema("Brooklyn Heights", "300 Cadman Plaza W", "Brooklyn", "NY", PHONE, url, description),
  ];
}
